// extracted by mini-css-extract-plugin
export default {"details":"details--OrtOB"};